import React from 'react'
import RsIcon from './icons/RsIcon'

export default function TrtcCallOverlay({
  callState,
  incomingCall,
  muted,
  cameraOff,
  onAccept,
  onDecline,
  onHangUp,
  onToggleMute,
  onToggleCamera,
  accepting,
}) {
  // Active/connecting call UI must win over incoming ring UI (video views live here).
  if (callState) {
    const isVideo = callState.mode === 'video'
    const statusLabel =
      callState.status === 'connecting'
        ? 'Connecting…'
        : callState.status === 'ended'
          ? callState.endReason === 'peer_left'
            ? 'Call ended'
            : 'Disconnected'
          : 'In call'

    return (
      <div className="rs-trtc-overlay">
        <div className={`rs-trtc-panel${isVideo ? ' video' : ''}`}>
          <div className="rs-trtc-header">
            <div>
              <h3 className="rs-trtc-title">{callState.peerName}</h3>
              <p className="rs-trtc-subtitle">{statusLabel}</p>
            </div>
            <span className="rs-trtc-mode-badge">{isVideo ? 'Video' : 'Voice'}</span>
          </div>

          {isVideo && (
            <div className="rs-trtc-video-stage">
              <div id="trtc-remote-view" className="rs-trtc-remote-view" />
              <div id="trtc-local-view" className="rs-trtc-local-view" />
            </div>
          )}

          {!isVideo && (
            <div className="rs-trtc-voice-stage">
              <div className="rs-trtc-avatar large">{callState.peerName?.slice(0, 1) || '?'}</div>
            </div>
          )}

          <div className="rs-trtc-toolbar">
            <button type="button" className={`rs-trtc-tool${muted ? ' off' : ''}`} onClick={onToggleMute} title={muted ? 'Unmute' : 'Mute'}>
              <RsIcon name={muted ? 'micOff' : 'mic'} size={20} />
            </button>
            {isVideo && (
              <button type="button" className={`rs-trtc-tool${cameraOff ? ' off' : ''}`} onClick={onToggleCamera} title={cameraOff ? 'Turn camera on' : 'Turn camera off'}>
                <RsIcon name={cameraOff ? 'videoOff' : 'videoCamera'} size={20} />
              </button>
            )}
            <button type="button" className="rs-trtc-tool hangup" onClick={onHangUp} title="Hang up">
              <RsIcon name="phoneOff" size={20} />
            </button>
          </div>
        </div>
      </div>
    )
  }

  if (incomingCall) {
    return (
      <div className="rs-trtc-overlay">
        <div className="rs-trtc-panel rs-trtc-incoming">
          <div className="rs-trtc-avatar">{incomingCall.callerName?.slice(0, 1) || '?'}</div>
          <h3 className="rs-trtc-title">
            {incomingCall.mode === 'video' ? 'Video' : 'Voice'} call
          </h3>
          <p className="rs-trtc-subtitle">{incomingCall.callerName} is calling…</p>
          <div className="rs-trtc-actions">
            <button type="button" className="rs-trtc-btn decline" onClick={onDecline} disabled={accepting}>
              Decline
            </button>
            <button type="button" className="rs-trtc-btn accept" onClick={onAccept} disabled={accepting}>
              {accepting ? 'Connecting…' : 'Accept'}
            </button>
          </div>
        </div>
      </div>
    )
  }

  return null
}
